module.exports = __webpack_public_path__ + "static/media/IMG_20210110_212238_853_tn.f27665a4.jpg";